import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postEmploy, jobDowlod, parentList, childList } from "@/api/management/staff";
import importExcel from "@/components/dialog/import/importExcel.vue";
export default {
  name: "search",
  components: {
    importExcel: importExcel
  },
  props: [],
  data: function data() {
    return {
      parentList: [],
      childList: [],
      searchData: {
        postTypeId: "",
        postGradeId: "",
        userName: ""
      },
      loading: false,
      current: 1,
      size: 10,
      total: 0,
      tableData: [],
      uplodData: {
        state: false,
        type: ""
      }
    };
  },
  computed: {},
  created: function created() {
    var _this = this;

    this.getParentList();
    this.$nextTick(function () {
      _this.initPage();
    });
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    initPage: function initPage() {
      this.current = 1;
      this.getList();
    },
    change: function change(value) {
      this.getChildList(value);
      this.searchData.postTypeId = "";
      this.initPage();
    },
    changeValue: function changeValue() {
      this.initPage();
    },
    // 获取岗位级别
    getParentList: function () {
      var _getParentList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$parentList, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return parentList();

              case 2:
                _yield$parentList = _context.sent;
                data = _yield$parentList.data;

                if (data.code == 0) {
                  this.parentList = data.data;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getParentList() {
        return _getParentList.apply(this, arguments);
      }

      return getParentList;
    }(),
    // 获取岗位等级
    getChildList: function () {
      var _getChildList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var _yield$childList, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return childList(id);

              case 2:
                _yield$childList = _context2.sent;
                data = _yield$childList.data;

                if (data.code == 0) {
                  this.childList = data.data;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getChildList(_x) {
        return _getChildList.apply(this, arguments);
      }

      return getChildList;
    }(),
    changePage: function changePage(page) {
      this.current = page;
      this.getCaseList();
    },
    getList: function () {
      var _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, _yield$postEmploy, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;
                params = _objectSpread(_objectSpread({}, this.searchData), {}, {
                  current: this.current,
                  size: this.size
                });
                _context3.next = 4;
                return postEmploy(params);

              case 4:
                _yield$postEmploy = _context3.sent;
                data = _yield$postEmploy.data;
                this.loading = false;

                if (data.code == 0) {
                  this.tableData = data.data.records;
                  this.total = data.data.total;
                } else {
                  this.$message.error(data.data.msg);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }(),
    reset: function reset() {
      this.searchData = {
        postTypeId: "",
        postGradeId: "",
        userName: ""
      };
      this.initPage();
    },
    closeUplod: function closeUplod(val) {
      this.uplodData.state = val;
    },
    saveSuccess: function saveSuccess() {
      this.initPage();
    },
    importExcel: function importExcel() {
      this.uplodData.state = true;
    },
    // 模板下载
    downloadTemplate: function downloadTemplate() {
      this.downloadFn(jobDowlod());
    },
    downloadFn: function downloadFn(url) {
      var _this2 = this;

      this.$DownLoad(url, null, function (res) {
        if (res.status != 200) {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  }
};